import React from 'react';

import getUid from '../utils/uidGenerator'
import '../utils/ArrayExtension'

//DMG style has to beimported

class Select extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            selectedId: -1,
            selectedText: undefined,
            onChangeFunction: this.props.onChange ? this.props.onChange : () => { }
        }

        this.clearSelection = false;
        this.options = this.props.options ? this.props.options : []

    }

    generateDiv = (options) => {
        if (this.props.isDisabled) {
            return;
        }
        if (options && !options.equals(this.options)) {
            this.clearSelection = true;
        }
        this.options = options ? options : []
        if (this.options.length <= 0) {
            return (
                <div
                    className="js-select-option ci-select-option"
                    data-value="0"
                >
                    No options
                </div>
            )
        }
        return this.options.map((e, i) => {
            return (
                <div
                    key={i}
                    className={"js-select-option ci-select-option" + ((this.state.selectedId === i) ? " ci-active" : "")}
                    onClick={() => {
                        this.clearSelection = false;
                        this.setState({
                            selectedId: i,
                            selectedText: e.displayName
                        });
                        this.state.onChangeFunction(e.data, i);
                    }}
                    data-value="0"
                >
                    {e.displayName}
                </div>
            )
        })
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
        if (this._isMounted) {

            if (this.clearSelection) {
                this.clearSelection = false;
                this.state.onChangeFunction(null, null);
                this.setState({
                    selectedId: -1,
                    selectedText: undefined
                })
            }
            if (this.props.selectedArea) {
                var idFromSelectForSelectedArea = this.options.findIndex(object => {
                    return object.data.id === this.props.selectedArea.id;
                });
                if (idFromSelectForSelectedArea > -1 && this.state.selectedId != idFromSelectForSelectedArea) {
                    this.setState({
                        selectedId: idFromSelectForSelectedArea,
                        selectedText: this.props.selectedArea.name
                    });
                }
            }
        }
    }


    setWindowClickListener = () => {
        window.onclick = () => {
            this.setState({
                open: false
            }, this.removeWindowClickListener)

        }
    }

    removeWindowClickListener = () => {
        window.onclick = undefined
    }


    render() {
        let uid = getUid();
        return (
            <div
                className={"js-select ci-floating-label ci-select" + (this.state.selectedText ? " ci-label-floating" : "") + (this.props.isDisabled ? " ci-disabled" : "")}
                onClick={(e) => {
                    if (this.props.isDisabled) {
                        return;
                    }
                    this.setState({
                        open: !this.state.open
                    }, this.setWindowClickListener)
                    e.stopPropagation();
                }}
            >
                <input name="select1" id={uid} key={uid} className="ci-input-element" readOnly inputMode="none" value={this.state.selectedText ? this.state.selectedText : ""} />
                <label htmlFor={uid}>
                    {this.props.label ? this.props.label : ""}
                </label>
                <div className={"js-select-options ci-select-options" + (this.state.open ? " ci-select-options-visible" : "")}>
                    {this.generateDiv(this.props.options)}
                </div>
                <div className="ci-validation-status js-status-message"></div>
            </div>

        )
    }
}

export default Select